import Swal from 'sweetalert2';

const useSwal = () => {

    const success = ({title, text = '', timer = 2000}) => {
        return Swal.fire({
            icon: 'success',
            title,
            text,
            timer,
            confirmButtonColor: '#3085d6'
        });
    };

    const error = ({title, text = '', timer = 2000}) => {
        return Swal.fire({
            icon: 'error',
            title,
            text,
            confirmButtonColor: '#d33',
            timer
        });
    };

    const warning = ({title, text = ''}) => {
        return Swal.fire({
            icon: 'warning',
            title,
            text,
            confirmButtonColor: '#f39c12'
        });
    };

    const info = ({title, text = ''}) => {
        return Swal.fire({
            icon: 'info',
            title,
            text
        });
    };

    const confirm = async ({

        title = 'Are you sure?',
        text = '',
        confirmButtonText = 'Yes'
    }) => {
        return await Swal.fire({
            title,
            text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText,
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33'
        });
    };

    return {
        success,
        error,
        warning,
        info,
        confirm
    };
};

export default useSwal;